import React, { useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import Moment from 'react-moment'
import { Button, Badge } from 'reactstrap'
import LoadingSpinner from '../../Shared/LoadingSpinner'
import PageHeading from '../../Shared/LayoutComponents/PageHeading'
import useFetchingCompanyHistory from './useFetchingCompanyHistory'
import { useDispatch } from 'react-redux'
import { fetchCompanyHistory } from '../../actions/companyActions'
import './synchistoryoverrides.css'

export const SyncHistory = (props) => {
  let [page, setPage] = useState(1)
  let [pageSize, setPageSize] = useState(10)

  let params = useParams()
  let dispatch = useDispatch()

  useFetchingCompanyHistory(params.companyId, page, pageSize)

  const handleTableChange = (type, rest) => {
    if (type === 'pagination') {
      setPage(rest.page)
      setPageSize(rest.sizePerPage)
      dispatch(fetchCompanyHistory(params.companyId, false, rest.page, rest.sizePerPage))
    }
  }

  const dateFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <Moment format="DD/MM/YYYY hh:mmA">{cell}</Moment>
  }

  const resultFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <h4 style={{ cursor: 'pointer' }}>
        {cell === 'Success' && <Badge color="success">{cell}</Badge>}
        {cell === 'Warning' && <Badge color="warning">{cell}</Badge>}
        {cell === 'Error' && <Badge color="error">{cell}</Badge>}
        {cell === 'Skipped' && <Badge color="secondary">{cell}</Badge>}
      </h4>
    )
  }

  const defaultSorted = [
    {
      dataField: 'syncDate',
      order: 'desc',
    },
  ]

  const expandRow = {
    parentClassName: 'detailsExpand',
    className: 'detailsExpandContent',
    showExpandColumn: true,
    expandColumnPosition: 'right',
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <PageHeading small>Change History</PageHeading>
        {row.syncChanges && row.syncChanges.length > 0 ? (
          row.syncChanges.map((row, index) => {
            return <div key={index}>{row}</div>
          })
        ) : (
          <div>No changes made</div>
        )}
      </div>
    ),
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return (
          <Button outline color="primary">
            Hide
          </Button>
        )
      }
      return <span>Expand</span>
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <Button size="sm" outline color="primary">
            Collapse
          </Button>
        )
      }
      return (
        <div>
          <Button size="sm" outline color="primary">
            Details
          </Button>
        </div>
      )
    },
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Id',
      hidden: true,
    },
    {
      dataField: 'syncDate',
      text: 'Date',
      sort: false,
      formatter: dateFormatter,
      // filter: dateFilter(),
      headerStyle: (column, colIndex) => {
        return { width: '350px' }
      },
    },
    {
      dataField: 'syncResult',
      text: 'Result',
      sort: false,
      formatter: resultFormatter,
      headerStyle: (column, colIndex) => {
        return { width: 'auto' }
      },
    },
  ]

  if (props.loading) {
    return <LoadingSpinner />
  } else if (props.selectedCompanyHistory && props.selectedCompanyHistory.length > 0) {
    return (
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          totalSize: props.selectedCompanyHistoryCount,
          page: page,
          sizePerPage: pageSize,
          sizePerPageList: [
            { text: '10', value: 10 },
            { text: '20', value: 20 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
          ],
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            bootstrap4
            keyField="id"
            data={props.selectedCompanyHistory}
            columns={columns}
            selectedCompany={props.selectedCompany}
          >
            {(props) => {
              return (
                <div>
                  <PaginationListStandalone {...paginationProps} />
                  <SizePerPageDropdownStandalone
                    btnContextual="btn-outline-primary"
                    className="dropDownStyle"
                    {...paginationProps}
                  />
                  <BootstrapTable
                    bordered={false}
                    keyField="id"
                    bootstrap4
                    defaultSorted={defaultSorted}
                    filterPosition="top"
                    {...props.baseProps}
                    loading={props.loading}
                    remote={{ pagination: true }}
                    columns={columns}
                    expandRow={expandRow}
                    onTableChange={handleTableChange}
                    {...paginationTableProps}
                  />
                </div>
              )
            }}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    )
  } else {
    return <div>No user syncronisations.</div>
  }
}

const mapStateToProps = (state) => ({
  loading: state.company.loadingHistory,
  selectedCompanyHistory: state.company.selectedCompanyHistory,
  selectedCompanyHistoryCount: state.company.selectedCompanyHistoryCount,
  selectedCompany: state.company.selectedCompany,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(SyncHistory)
